import { render } from "./MoreInfo.vue?vue&type=template&id=71c9ce5c&scoped=true"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"

import "./MoreInfo.vue?vue&type=style&index=0&id=71c9ce5c&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c9ce5c"]])

export default __exports__